// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"dc175b1b","405":"b8a5db1d","633":"8f60907b","669":"a09d6707","749":"f4da64e1","766":"b95f1c17","903":"abc6792f"}[chunkId] + ".chunk.js";
};